import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"
import Autosave from "stimulus-rails-autosave"
import RevealController from "@stimulus-components/reveal"
import TextareaAutogrow from "stimulus-textarea-autogrow"
import { Autocomplete } from "stimulus-autocomplete"
import env from "../utils/env"

window.Stimulus = Application.start()
const controllers = import.meta.glob("./**/*_controller.js", { eager: true })
registerControllers(Stimulus, controllers)

// Documentation:
// https://stimulus-components.netlify.app/docs/components/stimulus-rails-nested-form/
Stimulus.register("autosave", Autosave)
Stimulus.register("reveal", RevealController)
Stimulus.register("textarea-autogrow", TextareaAutogrow)
Stimulus.register("autocomplete", Autocomplete)

if (env === "test") {
  // propagate errors that happen inside Stimulus controllers
  Stimulus.handleError = (error, message, detail) => {
    throw error
  }
}
